module.exports = __webpack_public_path__ + "media/application/images/kids/CC-kids-logo-4871a33b225ba86ab90b2092f861eb0d.png";